import React from 'react';
import { Interactable, Background } from 'LocalGluons';
import { View, Text, Linking, Image } from 'react-native';
import { t } from 'Locale';
import styles from './AppPromo.jss';
import { APP_METADATA } from '../../../options';

const APP_PROMO_IMAGE = require('../../../../platformAssets/runtime/images/Apps.png');
const APP_STORE_IMAGE = require('../../../../platformAssets/runtime/images/CTA-AppStore.png');
const GOOGLE_PLAY_IMAGE = require('../../../../platformAssets/runtime/images/CTA-GooglePlay.png');

const AppPromo = () => (
    <Background style={styles.background}>
        <View style={styles.imageContainer}>
            <Image style={styles.image} source={APP_PROMO_IMAGE} />
        </View>
        <View style={styles.contentContainer}>
            <View style={styles.titleContainer}>
                <Text style={styles.title}>{t('COMMON.DOWNLOAD_APPS_PROMO_TITLE')}</Text>
            </View>
            <View style={styles.descriptionContainer}>
                <Text style={styles.description}>
                    {t('COMMON.DOWNLOAD_APPS_PROMO_DESCRIPTION')}
                </Text>
            </View>
            <View style={styles.storeButtonsContainer}>
                <Interactable
                    onPress={() => Linking.openURL(APP_METADATA.appstoreUrl)}
                    style={styles.storeImageContainer}
                >
                    <Image style={styles.storeImage} source={APP_STORE_IMAGE} />
                </Interactable>
                <Interactable
                    onPress={() => Linking.openURL(APP_METADATA.googleplayUrl)}
                    style={styles.storeImageContainer}
                >
                    <Image style={styles.storeImage} source={GOOGLE_PLAY_IMAGE} />
                </Interactable>
            </View>
        </View>
    </Background>
);

export default AppPromo;
